// Preload an image with optional fetch priority.
// Ensures we don't add duplicate <link rel="preload"> tags for the same href.
const preloaded = new Set<string>();

export function preloadImage(href: string, priority: 'high' | 'low' = 'high') {
  if (typeof document === 'undefined' || !href || preloaded.has(href)) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  // @ts-expect-error: fetchpriority is supported by modern browsers
  link.fetchpriority = priority;
  link.href = href;
  document.head.appendChild(link);
  preloaded.add(href);
}

export default preloadImage;
